var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/24/sort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1314829,14 C14.6837677,14 15.1314829,14.4477153 15.1314829,15 C15.1314829,15.197425 15.0730449,15.3904327 14.9635332,15.5547002 L12.8320503,18.7519246 C12.5256978,19.2114532 11.9048285,19.3356271 11.4452998,19.0292747 C11.3354475,18.9560398 11.2411846,18.8617768 11.1679497,18.7519246 L9.0364668,15.5547002 C8.73011434,15.0951715 8.85428821,14.4743022 9.3138169,14.1679497 C9.47808441,14.058438 9.67109211,14 9.86851709,14 L14.1314829,14 Z M12.5547002,4.97072534 C12.6645525,5.0439602 12.7588154,5.13822315 12.8320503,5.24807544 L14.9635332,8.4452998 C15.2698857,8.90482849 15.1457118,9.52569784 14.6861831,9.83205029 C14.5219156,9.94156197 14.3289079,10 14.1314829,10 L9.86851709,10 C9.31623234,10 8.86851709,9.55228475 8.86851709,9 C8.86851709,8.80257501 8.92695512,8.60956732 9.0364668,8.4452998 L11.1679497,5.24807544 C11.4743022,4.78854675 12.0951715,4.66437288 12.5547002,4.97072534 Z",
    id: "sort-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/24/sort",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sort-mask",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sort-path"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#FFFFFF",
    xlinkHref: "#sort-path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#sort-mask)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.b937af43b125427caea0a77e16a162cb.svg";
export { ForwardRef as ReactComponent };